import { render, staticRenderFns } from "./tabAddGolfer.vue?vue&type=template&id=e393bf40"
import script from "./tabAddGolfer.vue?vue&type=script&lang=js"
export * from "./tabAddGolfer.vue?vue&type=script&lang=js"
import style0 from "./tabAddGolfer.vue?vue&type=style&index=0&id=e393bf40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports